import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketYandexApi from '../../../API/market/yandex-api';
import PostingsYandexApi from '../../../API/shipment/postingsYandex-api';
import { uiChangeWbViewSize } from '../../../actions/ui';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { TablePagination } from '../../../components/Basic/Table';
import {
  MAP_SKLAD_RUS,
  MARKETS_MAP,
  TYPE_BUTTONS,
  YANDEX_1,
  YANDEX_1_EKB,
  YANDEX_2,
  YANDEX_3,
  YANDEX_3_EKB,
  YANDEX_4,
  YANDEX_4_EKB,
  YANDEX_5,
  YANDEX_5_EKB,
  YANDEX_6,
  YANDEX_7,
  YANDEX_7_EKB,
  YANDEX_8,
  YANDEX_MARKET_NAME,
  YANDEX_MARKETS_MAP_SKLAD,
  YANDEX_STATUS,
  YANDEX_SUBSTATUS,
  YANDEX_SUBSTATUS_ALL,
} from '../../../constans';
import { numberWithSpaces } from '../../../utils';
import YandexModalToShip from './ShipPopUp';
import YandexTableOrders from './TableOrders';
import YandexTableSizes from './TableSizes';
import { H2, Text } from '../../../components/Basic/WrapsStyle';

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 10 * 24 * 3600000);

  return start;
};

export const getPostingItemPrice = (p) => {
  return p.buyerPrice + (p.subsidies || []).reduce((acc, item) => acc + item.amount, 0);
};

const getInitState = () => {
  const start = CalcMonthAgo();
  const end = new Date();

  start.setTime(start.getTime() + 24 * 3600000);
  end.setTime(end.getTime() + 24 * 3600000);

  const fromDate = moment(start).format('DD-MM-YYYY');
  const toDate = moment(end).format('DD-MM-YYYY');

  return { fromDate, toDate };
};

const YandexPage = ({ ...props }) => {
  const [shop, setShop] = useState(YANDEX_1);
  const [showShipment, setShowShipment] = useState(false);
  const [skladName, setSkladName] = useState('Не выбран');
  const user = useSelector((store) => store.user);

  const [pager, setPager] = useState({});
  const [orders, setOrders] = useState([]);
  const [map, setMap] = useState({});
  const [calculation, setCalculation] = useState({ all: 0, allCom: 0, allProfit: 0, allPurchase: 0 });

  const [shipped, setSipped] = useState(false);

  const [status, setStatus] = useState('');
  const [substatus, setSubstatus] = useState(null);
  const [day, setDay] = useState(null);

  const [shipmentDate, setShipmentDate] = useState({ supplierShipmentDateFrom: null, supplierShipmentDateTo: null });
  const [periodtDate, setPeriodDate] = useState({});

  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: new Date() });

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const { is_check_size } = useSelector((store) => store.ui);
  const dispatch = useDispatch();

  const params = useMemo(() => {
    return {
      shop: skladName !== 'Не выбран' ? undefined : MARKETS_MAP[shop],
      status,
      subStatus: substatus || '',
      shipmentDate: shipmentDate.supplierShipmentDateFrom,
      fromDate: periodtDate.fromDate,
      toDate: periodtDate.toDate,
      page,
      skladName: skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : YANDEX_MARKETS_MAP_SKLAD[shop],
    };
  }, [shop, status, substatus, page, shipmentDate, periodtDate, skladName]);

  const getOrders = async () => {
    if (!params.fromDate) {
      return;
    }

    await PostingsYandexApi.getOrders({ data: params }).then((r) => {
      //setPager(r.pager);
      setOrders(r.postings);
      setMap(r.cardsMapByShop);
      setTotal(r.total);
    });
  };

  const shippedOrders = async (shipmentId, orderId) => {
    let postings = orders.map((item) => ({ postingNumber: item.id, shop: item.shop }));
    await PostingsYandexApi.collectOrders({
      data: {
        shop: skladName !== 'Не выбран' ? undefined : MARKETS_MAP[shop],
        skladName: skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : YANDEX_MARKETS_MAP_SKLAD[shop],
        postings,
        orderId, shipmentId,
      }
    }).then(async () => { });

    setSipped(false);
    await getOrders();

  };

  useEffect(() => {
    getOrders();
  }, [params]);

  const onChangeProduct = async (offer_id, shop, key, value) => {
    let setCard = (card) => {
      setMap({ ...map, [shop]: { ...map[shop], [card.offer_id]: card } });
    };

    if (key === 'stock') {
      return await MarketYandexApi.changeStock({ data: { shop, offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price' || key === 'discount') {
      return await MarketYandexApi.changePrice({ data: { shop, offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketYandexApi.changeMarginality({ data: { shop, offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketYandexApi.changeStopBrand({ data: { shop, offerIds: [offer_id], value } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    return await MarketYandexApi.changeCard({ data: { shop, offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const onChangePage = (p) => {
    setPage(p);
  };

  useEffect(() => {
    let supplierShipmentDateFrom;
    let supplierShipmentDateTo;

    const start = new Date(period.start);
    const end = new Date(period.end);

    start.setTime(start.getTime() + 24 * 3600000);
    end.setTime(end.getTime() + 24 * 3600000);

    const fromDate = moment(start).format('DD-MM-YYYY');
    const toDate = moment(end).format('DD-MM-YYYY');

    setPeriodDate({ fromDate, toDate });

    if (day) {
      const d = moment(day).format('DD-MM-YYYY');
      supplierShipmentDateFrom = d;
      supplierShipmentDateTo = d;
      setShipmentDate({ supplierShipmentDateFrom, supplierShipmentDateTo });
    }
  }, [day, period]);

  useEffect(() => {
    const res = orders.reduce(
      ({ all, allCom, allProfit, allPurchase }, order) => {
        const sum = order.buyerItemsTotal + (order.subsidies || []).reduce((acc, item) => acc + item.amount, 0);
        const oneOrder = order.items.reduce(
          ({ com, profit, purchase }, p) => {
            const cardMarket = { ...map[order.shop][p.offerId], price: getPostingItemPrice(p) };

            const item_quantity = p.count / (cardMarket.min_quantity || 1);
            com += p.commission.common?.rub * item_quantity; //data.loaded ? calcYandexCommission(data).all * (p.count / (data.min_quantity || 1)) : 0;
            profit += p.profit?.rub * item_quantity;
            purchase +=
              cardMarket.purchase * item_quantity * (cardMarket.min_quantity || 1) * (cardMarket.quantity || 1) || 0;

            return { sum, com, profit, purchase };
          },
          { sum: 0, com: 0, profit: 0, purchase: 0 },
        );
        return {
          all: all + sum,
          allCom: allCom + oneOrder.com,
          allProfit: allProfit + oneOrder.profit,
          allPurchase: allPurchase + oneOrder.purchase,
        };
      },
      { all: 0, allCom: 0, allProfit: 0, allPurchase: 0 },
    );

    setCalculation(res);
  }, [orders]);

  useEffect(() => {
    const d = getInitState();
    setPeriodDate(d);
  }, []);

  return (
    <>
      <Content>
        <WhiteBlock style={{ minWidth: '500px' }}>
          <Row style={{ marginBottom: '20px' }} >
            <div style={{ marginRight: '15px' }} >
              <Select
                label="Выбрать город"
                big={true}
                select={skladName}
                width="200px"
                onSelect={(m) => {
                  // setPostings([]);
                  setSkladName(m);
                }}
                list={['Москва', 'Екатеринбург', 'Не выбран']}
              />
            </div>
          </Row>
          <Row style={{ marginTop: '10px', alignItems: 'end' }}>
            <Select
              label="Магазин"
              select={skladName === 'Не выбран' ? { shop, name: YANDEX_MARKET_NAME[shop] } : { shop: 'all', name: 'Все' }}
              width={'200px'}
              valueFn={(f) => f.name}
              disabled={skladName !== 'Не выбран'}
              style={{ marginRight: '15px' }}
              list={[
                { name: YANDEX_MARKET_NAME[YANDEX_1], shop: YANDEX_1 },
                { name: YANDEX_MARKET_NAME[YANDEX_3], shop: YANDEX_3 },
                { name: YANDEX_MARKET_NAME[YANDEX_4], shop: YANDEX_4 },
                { name: YANDEX_MARKET_NAME[YANDEX_5], shop: YANDEX_5 },
                { name: YANDEX_MARKET_NAME[YANDEX_6], shop: YANDEX_6 },
                { name: YANDEX_MARKET_NAME[YANDEX_7], shop: YANDEX_7 },
                { name: YANDEX_MARKET_NAME[YANDEX_2], shop: YANDEX_2 },
                { name: YANDEX_MARKET_NAME[YANDEX_8], shop: YANDEX_8 },
                { name: YANDEX_MARKET_NAME[YANDEX_1_EKB], shop: YANDEX_1_EKB },
                { name: YANDEX_MARKET_NAME[YANDEX_3_EKB], shop: YANDEX_3_EKB },
                { name: YANDEX_MARKET_NAME[YANDEX_4_EKB], shop: YANDEX_4_EKB },
                { name: YANDEX_MARKET_NAME[YANDEX_5_EKB], shop: YANDEX_5_EKB },
                { name: YANDEX_MARKET_NAME[YANDEX_7_EKB], shop: YANDEX_7_EKB },
              ]}
              onSelect={(v) => {
                setPage(1);
                console.log(v.shop);
                setShop(v.shop);
              }}
            />
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput value={period.start} onChange={(v) => setPeriod({ ...period, start: new Date(v) })} />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput value={period.end} onChange={(v) => setPeriod({ ...period, end: new Date(v) })} />
              </Row>
            </Column>
          </Row>
          <Row style={{ marginTop: '10px', alignItems: 'end' }}>
            <Select
              label="Статус"
              select={status}
              width={'200px'}
              valueFn={(f) => YANDEX_STATUS[f]}
              style={{ marginRight: '20px' }}
              list={Object.keys(YANDEX_STATUS)}
              onSelect={(v) => {
                setPage(1);
                setStatus(v);
                if (v === 'PROCESSING') {
                  setSubstatus('STARTED');
                } else if (v === 'CANCELLED') {
                  setSubstatus('');
                } else {
                  setSubstatus(null);
                }
              }}
            />
            {(substatus === '' || substatus) && (
              <Select
                label="Подстатус"
                select={substatus}
                width={'200px'}
                style={{ marginRight: '20px' }}
                valueFn={(f) => YANDEX_SUBSTATUS_ALL[f]}
                list={Object.keys(YANDEX_SUBSTATUS[status])}
                onSelect={(v) => {
                  setPage(1);
                  setSubstatus(v);
                }}
              />
            )}
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Row>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => PostingsYandexApi.getOrdersExcel({ data: { ...params, page: undefined } })}
                style={{ marginRight: '20px' }}
              >
                Скачать заказы
              </Button>
              <Button type={TYPE_BUTTONS.GREEN}
                onClick={() => setSipped(true)}
              //  disabled={substatus !== 'STARTED'}
              >
                Собрать заказы
              </Button>

            </Row>
          </Row>
        </WhiteBlock>

        <Row spaceBetween={true} style={{ marginTop: '-20px' }}>
          <div />
          <Row>
            <CheckButton
              checked={is_check_size}
              onSelect={() => dispatch(uiChangeWbViewSize(!is_check_size))}
              style={{ marginRight: '15px' }}
            />
            <Text style={{ marginTop: '4px', marginBottom: '5px' }}>Проверка габаритов</Text>
          </Row>
        </Row>

        {is_check_size ? (
          <YandexTableSizes
            shop={shop}
            total={total}
            orders={orders}
            map={map}
            pager={pager}
            onChange={onChangeProduct}
          />
        ) : (
          <YandexTableOrders
            shop={shop}
            total={total}
            orders={orders}
            map={map}
            pager={pager}
            onChange={onChangeProduct}
          />
        )}

        <TablePagination num={Math.ceil(total / 50) || 1} show={page} onChange={onChangePage} />
        {shipped && <YandexModalToShip skladName={skladName} market={shop} day={day} clickOk={shippedOrders} close={() => setSipped(false)} />}

        {calculation && (user.role === 'owner' || user.role === 'admin') && (
          <div style={{ marginTop: '10px' }}>
            <H2>Заказов на сумму: {numberWithSpaces(calculation.all.toFixed(0))}</H2>
            <H2>Комиссия: {numberWithSpaces(calculation.allCom.toFixed(0))}</H2>
            <H2>Закупка: {numberWithSpaces(calculation.allPurchase.toFixed(0))}</H2>

            <H2>Прибыль: {numberWithSpaces(calculation.allProfit.toFixed(0))}</H2>
            <H2>
              Маржинальность: ~{' '}
              {numberWithSpaces(Math.ceil((calculation.allProfit * 100) / calculation.allPurchase) || 0)} %
            </H2>
          </div>
        )}
      </Content>
    </>
  );
};

export default YandexPage;
